import {atom} from "recoil";
import {
  CloverRestaurantDto,
  DesignDto,
  LocationDto,
  MemberDtoPlanEnum,
  SquareRestaurantDto,
  ToastRestaurantDto,
  TreezRestaurantDto,
  PopmenuRestaurantDto,
} from "../generated/dashboard-client";
import {AddOnDto} from "../generated/account-client";
import {CloverUpdateByDesign, SquareUpdateByDesign, ToastUpdateByDesign, TreezUpdateByDesign, PopmenuUpdateByDesign} from "../util/types";

export interface MemberState {
  id: string;
  internalId: number;
  teamId: string;
  logged: boolean;
  plan: MemberDtoPlanEnum;
  email: string;
  name: string;
  owner: boolean;
  oldLoginKey: string;
  printInvoicing: boolean;
  subscriptionInvoicing: boolean;
  downloads: boolean;
  printing: boolean;
  templates: boolean;
}

export interface CartState {
  menus: string[];
}

export const memberState = atom({
  key: "memberState",
  default: {
    id: "",
    teamId: "",
    internalId: 0,
    logged: false,
    plan: MemberDtoPlanEnum.Free as MemberDtoPlanEnum,
    email: "",
    name: "",
    owner: false,
    oldLoginKey: "",
    status: 0,
    clover: false,
    ownerId: 0,
    dsaBeta: false,
    printInvoicing: false,
    subscriptionInvoicing: false,
    downloads: false,
    printing: false,
    templates: false,
    viewOnly: false,
    partner: ""
  },
});

export const cartState = atom({
  key: "cartState",
  default: {
    menus: [] as string[]
  },
});

export const printProductionState = atom({
  key: "printProductionState",
  default: {
    menus: [] as string[]
  }
});

export const posState = atom({
  key: "posState",
  default: {
    enabled: false,
    toastEmail: "",
    isClover: false,
    isToast: false,
    isSquare: false,
    isTreez: false,
    isPopmenu: false,
  },
});

export const locationsState = atom({
  key: "locationsState",
  default: [] as LocationDto[],
});

export const availableAddonsState = atom({
  key: "availableAddonsState",
  default: [] as AddOnDto[],
});

export const toastRestaurantsState = atom({
  key: "toastRestaurantState",
  default: [] as ToastRestaurantDto[],
});

export const cloverRestaurantsState = atom({
  key: "cloverRestaurantState",
  default: [] as CloverRestaurantDto[],
});

export const squareRestaurantsState = atom({
  key: "squareRestaurantsState",
  default: [] as SquareRestaurantDto[],
});

export const treezRestaurantsState = atom({
  key: "treezRestaurantsState",
  default: [] as TreezRestaurantDto[],
});

export const popmenuRestaurantsState = atom({
  key: "popmenuRestaurantsState",
  default: [] as PopmenuRestaurantDto[],
});

export const toastDeltaUpdatesState = atom({
  key: "toastDeltaUpdatesState",
  default: {} as ToastUpdateByDesign
});

export const cloverDeltaUpdatesState = atom({
  key: "cloverDeltaUpdatesState",
  default: {} as CloverUpdateByDesign
});

export const squareDeltaUpdatesState = atom({
  key: "squareDeltaUpdatesState",
  default: {} as SquareUpdateByDesign
});

export const treezDeltaUpdatesState = atom({
  key: "treezDeltaUpdatesState",
  default: {} as TreezUpdateByDesign
});

export const popmenuDeltaUpdatesState = atom({
  key: "popmenuDeltaUpdatesState",
  default: {} as PopmenuUpdateByDesign
});

export const designUsingToastState = atom({
  key: "designUsingToastState",
  default: [] as DesignDto[]
});

export const designUsingCloverState = atom({
  key: "designUsingCloverState",
  default: [] as DesignDto[]
});

export const designUsingSquareState = atom({
  key: "designUsingSquareState",
  default: [] as DesignDto[]
});

export const designUsingTreezState = atom({
  key: "designUsingTreezState",
  default: [] as DesignDto[]
});

export const designUsingPopmenuState = atom({
  key: "designUsingPopmenuState",
  default: [] as DesignDto[]
});

export const mobileState = atom({
  key: "mobileState",
  default: false
});

export const paymentJsLoadedState = atom({
  key: "paymentJsLoadedState",
  default: false
});
